import { createSelector } from '@ngrx/store';
import { presenceContactRegisterSelector } from './presence-contact-register.reducer';

export const selectFilters = createSelector(presenceContactRegisterSelector, (state) => {
   return state.filters;
});

export const selectPresenceRefresh = createSelector(presenceContactRegisterSelector, (state) => {
   return state.presenceRefresh;
});
